(function () {
  $(document).ready(function () {
    $(document).on("swell:setup", function () {
      
     if(window.location.href.includes("cart")||window.location.href.includes("checkout")){
        
      jQuery.getJSON("/cart.js",function(response){
        var cartproducts = response.items;
        let freeGiftVariant = 20231065993289;
        if(cartproducts.length<1) {
          return;
        }
        let validItem = false;
        let hasFreeGift = false;
        let believer = spapi.customer.tags.includes("swell_vip_believer");
        // don't add free gift for gift card only purchases
        let excludedVariants = [freeGiftVariant, 14461239787593,14461239820361,16628584972361,14461239853129];
        cartproducts.forEach(function (cp) {
          if(!excludedVariants.includes(cp.variant_id)){
              validItem = true;
          }
          if (cp.variant_id == freeGiftVariant) {
            hasFreeGift = true;
          }
        });
        if (believer && validItem && !hasFreeGift) {
          jQuery.post('/cart/add.js', {
            items: [
              {
                quantity: 1,
                id: freeGiftVariant
              }
            ]
          }, function( data ) {
            setTimeout(function(){
                window.location = window.location;
            },1000);
          }, "json");
        } else if (!validItem && hasFreeGift || !believer && hasFreeGift) {
          let updateData = { updates: {[freeGiftVariant]: 0}};
          jQuery.post('/cart/update.js', updateData, function(res){
             window.location = window.location;
          });
        }
      
      });
  
    } 
      
      
      if (window.location.href.indexOf("checkouts") > -1 && $("#swell-checkout").length > 0) {
        $(".order-summary-toggle").click();
      }

      Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
      SwellConfig.Campaign.customCampaign();

      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      SwellConfig.Referral.populateReferrals(".swell-referral-table .table-data");
      $("#swell-post-checkout").show();

      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table");
      SwellConfig.Tier.showCurrentTierColumnMobile();

      $(".swell-referral-loader").hide();

      $('body').on('click', '.swell-tier-arrows .right-arrow', function () {
        if ($(".swell-tier-table").hasClass("supporter")) {
          $(".swell-tier-table").removeClass("supporter");
          $(".swell-tier-table").addClass("lover");
        } else if ($(".swell-tier-table").hasClass("lover")) {
          $(".swell-tier-table").removeClass("lover");
          $(".swell-tier-table").addClass("believer");
        } else if ($(".swell-tier-table").hasClass("believer")) {
          $(".swell-tier-table").removeClass("believer");
          $(".swell-tier-table").addClass("supporter");
        }
      });

      $('body').on('click', '.swell-tier-arrows .left-arrow', function () {
        if ($(".swell-tier-table").hasClass("supporter")) {
          $(".swell-tier-table").removeClass("supporter");
          $(".swell-tier-table").addClass("believer");
        } else if ($(".swell-tier-table").hasClass("believer")) {
          $(".swell-tier-table").removeClass("believer");
          $(".swell-tier-table").addClass("lover");
        } else if ($(".swell-tier-table").hasClass("lover")) {
          $(".swell-tier-table").removeClass("lover");
          $(".swell-tier-table").addClass("supporter");
        }
      });

      $(document).on("swell:referral:success", function () {
        swellAPI.refreshCustomerDetails(function () {
          SwellConfig.Referral.populateReferrals(".swell-referral-table .table-data");
        });
      });

      $(document).on("swell:referral:error", function (jqXHR, textStatus, errorThrown) {
        $(".refer-customer-error").remove();
        var error_message = "";
        if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
          error_message = '<p class="refer-customer-error">Oops! Looks like this person already has an account. Try referring another friend.</p>';
        } else if (textStatus && textStatus === "Please enter a valid email address") {
          error_message = '<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>';
        }

        $(".swell-referral-form-header-details").append(error_message);
        $("#swell-referral-refer-emails").addClass("error-border");
      });

      $('body').on('click', '.close-checkout-popup', function () {
        $("#swell-post-checkout").hide();
      });

      $('body').on('click', '.newsletter-campaign', function () {
        if (spapi.authenticated) {
          swellAPI.showPopupByType("EmailCapturePopup");
        }
      });

    });
  });
}).call(this);

(function () {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: '<li class="swell-campaign <%= campaign.type %>"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-value"> <span class="swell-campaign-heart swell-icon-heart-pink-line"></span> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> <div class="swell-campaign-icon"><span class="swell-campaign-icon-content"><i class="<%= campaign.icon %>"></i></span></div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> </div> </li>'
      }
    },
    customCampaign: function () {
      $(".swell-campaign-list").append('<li class="swell-campaign swell-custom-campaign"> <div class="swell-campaign-content"> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">You’ve totally got this!!</span> </div> <div class="swell-custom-campaign-image"> <img src="//cadenshae.com.au/cdn/shop/t/7/assets/swell-custom-campaign-image.png?v=33122768772720474141568814443" alt="caption_img" class="swell-campaign-logo"> </div> </div> </li>');
    }
  };

}).call(this);

(function () {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    opts: {
      templates: {
        redemptionOption: '<li class="list-items"> <div class="list-items-holder"> <span class="point-value"> <i class="swell-icon-heart"></i> <%= redemption.amount %> </span> <span class="is-equal">=</span> <span class="point-value"> <i class="swell-icon-star-line"></i> <%= redemption.name %> </span> </div> </li>'
      }
    }
  };

}).call(this);

(function () {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralRegisterHeading: "<i class='swell-heart-icon swell-icon-heart-pink-line'></i><span class='refer-heading'>REFER A FRIEND</span>Give 15%, Get 20%",
        referralRegisterFormDetails: "Please submit your email below to get started",
        referralRegisterFormEmail: "Enter email",
        referralRegisterFormSubmit: "Start Referring Now",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "<i class='swell-heart-icon swell-icon-heart-pink-line'></i><span class='refer-heading'>REFER A FRIEND</span>Give 15%, Get 20%",
        referralReferFormEmails: "Enter email",
        referralReferFormSubmit: "Send",
        referralReferFormDetails: "Now, enter your friends’ email below.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share your link with the buttons below.",

        referralShareFacebook: "Share",
        referralShareMessenger: "Message",
        referralShareSMS: "SMS",
        referralShareCopy: "Copy Link",

        referralFacebookIcon: "swell-icon-fb",
        referralMessengerIcon: "swell-icon-message",
        referralSMSIcon: "swell-icon-SMS",
        referralLinkIcon: "swell-icon-copy-link",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: 'Remind your friends to check their emails or share the code with the links below:'+
                        '<div class="swell-referral-media-wrapper" style="margin-top: -60px;">'+
                        '<ul class="swell-referral-media-list">'+
                        '<li class="swell-referral-medium swell-share-referral-facebook" style="margin-right:30px;">'+
                        '<div class="swell-referral-medium-content">'+
                        '<i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>'+
                        '<div> <%= localization.referralShareFacebook %> </div>'+
                        '</div>'+
                        '</li>'+
                        '<li class="swell-referral-medium swell-share-referral-messenger" style="margin-right:30px;">'+
                        '<div class="swell-referral-medium-content">'+
                        '<i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i>'+
                        '<div> <%= localization.referralShareMessenger %> </div>'+
                        '</div>'+
                        '</li>'+
                        '<li class="swell-referral-medium swell-share-referral-sms show-on-mobile" style="margin-right:30px;">'+
                        '<div class="swell-referral-medium-content">'+
                        '<i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i>'+
                        '<div> <%= localization.referralShareSMS %> </div>'+
                        '</div>'+
                        '</li>'+
                        '<li class="swell-referral-medium swell-share-referral-copy" style="margin-right:30px;">'+
                        '<div class="swell-referral-medium-content" style="width: max-content;">'+
                        '<i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>'+
                        '<div> <%= localization.referralShareCopy %> </div>'+
                        '</div> </li> </ul> </div>',

        referralCopyHeading: "",
        referralCopyButton: "COPY LINK",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"> <%= localization.referralReferDetails %> </p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralReferFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> </li> </ul> </div> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"> <%= localization.referralReferMediaDetails %> </p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i> <div> <%= localization.referralShareFacebook %> </div> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i> <div> <%= localization.referralShareMessenger %> </div> </div> </li> <li class="swell-referral-medium swell-share-referral-sms show-on-mobile"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i> <div> <%= localization.referralShareSMS %> </div> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i> <div> <%= localization.referralShareCopy %> </div> </div> </li> </ul> </div> </div>'
      }
    },
    populateReferrals: function (containerSelector) {
      if (spapi.authenticated) {
        if ($(containerSelector).length == 0) {
          return;
        }
        $(containerSelector).html("");
        var referral_receipts = spapi.customer.referral_receipts;
        if (referral_receipts.length > 0) {
          $.each(referral_receipts, function (index, item) {
            status = "Invited";
            if (item.completed_at != null) {
              status = "<span>Purchased</span>" + " (" + spapi.activeReferralCampaign.reward_text + " earned" + ")";
            }
            $(containerSelector).append("<tr><td>" + item.email + "</td><td>" + status + "</td></tr>");
          });
        }
      }
    }
  };

}).call(this);

(function () {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    showCurrentTierColumnMobile: function () {
      if (spapi.authenticated) {
        var customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
        var active_tier = "";
        if (customer_tier_rank == 0) {
          active_tier = "supporter";
        } else if (customer_tier_rank == 1) {
          active_tier = "lover";
        } else if (customer_tier_rank == 2) {
          active_tier = "believer";
        }
        $(".swell-tier-table").addClass(active_tier);
      } else {
        $(".swell-tier-table").addClass("supporter");
      }
    },
    getCustomerTierId: function () {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function () {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function (e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function (rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function (e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function () {
      var customer_tier_id, customer_tier_rank, next_tier, points_required;

      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);

      $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <th scope=\"row\"></th>\n</tr>");
      $.each(spapi.activeVipTiers, function (index, tier) {
        $(".swell-tier-status-row").append("<th data-tier-id='" + tier.id + "'></th>");
        $($('.swell-status-row li')[index]).attr("data-tier-id", tier.id);
      });

      $("[data-tier-id=\"" + customer_tier_id + "\"]").addClass("swell-tier-active");
      $(".swell-tier-status-row th[data-tier-id=\"" + customer_tier_id + "\"]").append("<span class= 'current-status'>CURRENT<br> STATUS</span>");

      if (customer_tier_id != spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
        var points_required = next_tier.points_earned - spapi.customer.points_earned;
        var referrals_completed = 0;

        $.each(spapi.customer.referral_receipts, function (index, referral_receipt) {
          if (referral_receipt.completed_at != null) {
            referrals_completed = referrals_completed + 1;
          }
        });

        referrals_required = next_tier.referrals_completed - referrals_completed;
        if (points_required < 0) {
          points_required = 0;
        }

        $(".swell-tier-status-row th[data-tier-id=\"" + next_tier.id + "\"]").append("<span class='next-status'>Earn " + points_required + " hearts or make " + referrals_required + " referrals to earn " + next_tier.name + "</span>");
      }
    },
    initializeDummyTier: function () {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "SUPPORTER",
        updated_name: "<div class='list-tier'>TIER 01</div> SUPPORTER",
        points: "<div class='referral-hearts'>0–199 Hearts or make 0–7 Successful referrals</div>",
        multiplier: "$1 = 1 <i class='swell-icon-heart-pink-line'></i>",
        birthday_rewards: "<i class=\"swell-icon-heart\" aria-hidden=\"true\"></i>",
        early_access: "<span class='swell-table-border'></span>",
        photoshoot: "<span class='swell-table-border'></span>",
        free_gift: "<span class='swell-table-border'></span>",
        free_tickets: "<span class='swell-table-border'></span>",
        swellrequiredAmountSpent: "$0",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function () {
      spapi.activeVipTiers[1].name = spapi.activeVipTiers[1].name;
      spapi.activeVipTiers[1].updated_name = "<div class='list-tier'>TIER 02</div>" + spapi.activeVipTiers[1].name;
      spapi.activeVipTiers[1].points = "<div class='referral-hearts'>" + spapi.activeVipTiers[1].points_earned + "–" + (spapi.activeVipTiers[2].points_earned - 1) + " Hearts or make " + spapi.activeVipTiers[1].referrals_completed + "–" + (spapi.activeVipTiers[2].referrals_completed - 1) + " Successful referrals </div>";
      spapi.activeVipTiers[1].multiplier = "$1 = 1.1 <i class='swell-icon-heart-pink-line'></i>";
      spapi.activeVipTiers[1].birthday_rewards = "<i class=\"swell-icon-heart\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[1].early_access = "<i class=\"swell-icon-heart\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[1].photoshoot = "<i class=\"swell-icon-heart\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[1].free_gift = "<span class='swell-table-border'></span>";
      spapi.activeVipTiers[1].free_tickets = "<span class='swell-table-border'></span>";

      spapi.activeVipTiers[2].name = spapi.activeVipTiers[2].name;
      spapi.activeVipTiers[2].updated_name = "<div class='list-tier'>TIER 03</div>" + spapi.activeVipTiers[2].name;
      spapi.activeVipTiers[2].points = "<div class='referral-hearts'>" + spapi.activeVipTiers[2].points_earned + "+ Hearts or make " + spapi.activeVipTiers[2].referrals_completed + "+ Successful referrals </div>";
      spapi.activeVipTiers[2].multiplier = "$1 = 1.25 <i class='swell-icon-heart-pink-line'></i>";
      spapi.activeVipTiers[2].birthday_rewards = "<i class=\"swell-icon-heart\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].early_access = "<i class=\"swell-icon-heart\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].photoshoot = "<i class=\"swell-icon-heart\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].free_gift = "<i class=\"swell-icon-heart\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].free_tickets = "<i class=\"swell-icon-heart\" aria-hidden=\"true\"></i>";
    },
    initializeTiers: function (containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          updated_name: {
            className: "swell-tier-names",
            title: "<div class='reward-title'>The Rewards <i class='swell-icon-star'></i></div>"
          },
          points: {
            className: "swell-tier-values",
            title: ""
          }
        },
        body: {
          multiplier: {
            title: "Heart multiplier"
          },
          birthday_rewards: {
            title: "Birthday rewards"
          },
          early_access: {
            title: "Early access to new products"
          },
          photoshoot: {
            title: "Photoshoot & social media spotlight opportunities"
          },
          free_gift: {
            title: "Free gift with purchase*"
          },
          free_tickets: {
            title: "Free Event tickets"
          }
        }
      };
      $(containerSelector).append("<thead></thead>");
      $(containerSelector).append("<tbody></tbody>");
      j = 0;
      ref = properties.header;
      for (key in ref) {
        property = ref[key];
        $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function (tier) {
          return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope=\"col\" data-tier-id=\"" + tier.id + "\">" + tier[key] + "</th>");
        });
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr>\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function (tier) {
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\">" + tier[key] + "</td>");
        });
        i++;
      }
      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      }
    }
  };

}).call(this);
